import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPorIdPorCredenciado(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/fornecedores/entregas/${entregaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/credenciados/fornecedores/entregas/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirEntregaAnexo(entregaAnexo) {
        const formData = new FormData()
        formData.append('entregaId', entregaAnexo.entregaId)
        formData.append('tipoId', entregaAnexo.tipoId)
        formData.append('descritivo', entregaAnexo.descritivo)
        formData.append('arquivo', entregaAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/credenciados/fornecedores/entregas/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirEntregaAnexo(entregaAnexoId) {
        return axiosJwt
            .delete(
                `${api}/credenciados/fornecedores/entregas/anexos/${entregaAnexoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarEntregaRaht(raht) {
        return axiosJwt
            .post(`${api}/credenciados/fornecedores/entregas/raht`, raht)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarEntregaParaAprovacao(entregaParaAprovacao) {
        return axiosJwt
            .post(
                `${api}/credenciados/fornecedores/entregas/enviar`,
                entregaParaAprovacao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterEntregaAnexo(entregaAnexoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/fornecedores/entregas/anexos/${entregaAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/fornecedores/entregas/${entregaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
